import type { Envelope } from '../types';
import { PROTOCOL_VERSION } from '../protocol';
import { uuidv4 } from '../utils/uuid';

/**
 * Normalize a legacy `configurator:v1` message into the modern envelope format.
 * Returns `null` if the data doesn't match the legacy shape.
 */
export function normalizeLegacyToEnvelope(
  data: Record<string, any>,
  fallbackContext: { sessionId: string; viewerType: string; schemaVersion: string },
): Envelope | null {
  if (data?.protocol !== 'configurator:v1') return null;
  const type = data?.type;
  if (!type || typeof type !== 'string') return null;

  const sessionId = data.sessionId || fallbackContext.sessionId;
  const viewerType = data.viewerType || fallbackContext.viewerType;
  const schemaVersion = data.schemaVersion || fallbackContext.schemaVersion;
  const requestId = data.requestId || uuidv4();

  let payload: Record<string, unknown> = {};
  if (type === 'INIT') payload = { options: data.options || {} };
  else if (type === 'SET_OPTION') payload = { key: data.key, value: data.value, source: data.source };
  else if (type === 'SET_OPTIONS') payload = { patch: data.patch || {}, source: data.source };
  else if (type === 'COMMIT') payload = { reason: data.reason || 'unknown' };
  else payload = data.payload || {};

  return { protocolVersion: PROTOCOL_VERSION, type, requestId, sessionId, viewerType, schemaVersion, payload };
}
